package org.vreo.devicehub.features.device.presentation.deviceManagement.mainDeviceNavigation

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.flow.update

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope

/**
 * Device management view model
 */
class DeviceManagementViewModel() : ViewModel() {
    private val _state = MutableStateFlow(DeviceManagementState())
    val state = _state.stateIn(
        scope = viewModelScope,
        started = SharingStarted.WhileSubscribed(5000L),
        initialValue = _state.value
    )

    /**
     * Handel all user actions
     *
     * @param action action to handle
     */
    fun onAction(action: DeviceManagementActions) {
        when (action) {
            is DeviceManagementActions.OnBackNavigation -> {}

            is DeviceManagementActions.OnUpdateTabIndex -> {
                _state.update {
                    it.copy(
                        selectedTabIndex = action.index
                    )
                }
            }
        }
    }
}